import ActionConstants from "../action-constants";
import { createReducer } from "../utils/redux-util";
import Reducer from "./reducer";

class CartListModelReducer extends Reducer {
    static getModelData(state = initialState, action) {
        return {
            ...state,
            cartListModelData: {
                getModelAData: action.payload
            } 
        }
    }
}

const cartListModelActionHandlers = {
    [ActionConstants.GET_MODEL_NAME]: CartListModelReducer.getModelData
}

const initialState = {
    cartListModelData: {
        getModelAData: []
    }
}

export const cartListModelData = createReducer(initialState, cartListModelActionHandlers) 